// extracted by mini-css-extract-plugin
export default {"PipelineStatus":"TaskStatusIcon_PipelineStatus__b3Ux3","PipelineStatus__Icon":"TaskStatusIcon_PipelineStatus__Icon__q5Kxl"};